export enum ClientTypeEnum {
  BUSINESS = 1,
  PRIVATE = 2
}